import React, { useEffect } from "react";
import "./error404.scss";
import { useNavigate, useParams } from "react-router-dom";
import productStore from "../../store/productStore";
import { Button, Stack } from "@mui/material";

// Icons
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import brandStore from "../../store/brandStore";

const Error404 = () => {
  const navigate = useNavigate();
  const params = useParams();
  const ProductStore = productStore();
  const BrandStore = brandStore();

  useEffect(() => {
    init();
  }, [params.id]);

  const init = async () => {
    window.scrollTo({ top: 0 });
    let flag = 0;

    if (ProductStore.product !== null) {
      await ProductStore.product.filter((item) => {
        return item._id === params.id && flag++;
      });
    } else {
      const product = await ProductStore.fetchOneProduct({ _id: params.id });

      if (product) {
        flag++;
      }
    }
    if (flag) {
      if (params.gender) {
        navigate(
          `/${params.gender}/${params.productCategory}/${params.productName}/${params.id}/details`,
          { replace: true }
        );
      } else {
        navigate(
          `/${params.productCategory}/${params.productName}/${params.id}/details`,
          { replace: true }
        );
      }
    }
  };

  return (
    <div className="error-404">
      <Stack spacing={2}>
        <div className="h1-404">404</div>
        <div className="title">SORRY, PAGE NOT FOUND</div>
        <div className="desc">The page you are looking for not available!</div>
        <div className="go-home">
          <Button
            variant="contained"
            startIcon={<HomeRoundedIcon />}
            className="icon"
          >
            <p>Back To Home</p>
          </Button>
        </div>
        <p>© 2025 {BrandStore.brand.brandName}, All Rights Reserved</p>
      </Stack>
    </div>
  );
};

export default Error404;
